<template>
  <div class="container-subtitle-settings">
    <AuxiliaryDisplayControlSubtitle ref="refControlSubtitle" :is-global="true" />

    <div class="footer-subtitle-settings">
      <ButtonProcess full-width secondary @click="emit('close')">
        {{ t('close') }}
      </ButtonProcess>
      <ButtonProcess full-width @click="saveSettingsSubtitle">
        {{ t('keep_current_settings') }}
      </ButtonProcess>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, provide, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

import AuxiliaryDisplayControlSubtitle from '@/components/domains/chat/chat-general/AuxiliaryDisplayControlSubtitle.vue';
import ButtonProcess from '@/components/shared/base/ButtonProcess.vue';
import { usePreferences } from '@/composables/shared/usePreferences';
import { useSocketStore } from '@/stores/socket';
import { useToastStore } from '@/stores/toast';
import { AuxiliaryDisplayControlScreenExposed } from '@/types/components';
import { ij_isModeSubtitle } from '@/utils/injectionKeys.js';

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();
const { isValidPreference } = usePreferences();

const toastStore = useToastStore();
const route = useRoute();
const socketStore = useSocketStore();

const refControlSubtitle = ref<AuxiliaryDisplayControlScreenExposed>();

const isModeSubtitle = computed(() => {
  const isMetaSubtitle = route.meta.chatType === 'SUBTITLE';
  const isConnectionSubtitle = socketStore.connectInfo?.connectionType === 'SUBTITLE';
  return isMetaSubtitle || isConnectionSubtitle;
});

const saveSettingsSubtitle = () => {
  const settingsSubtitle = refControlSubtitle.value?.payloadMessageFc.subtitleAttribute;

  if (!settingsSubtitle || !isValidPreference(settingsSubtitle)) return;

  localStorage.setItem('settings_subtitle', JSON.stringify(settingsSubtitle));

  toastStore.info(t('alert_save_completed'));
  emit('close');
};

provide(ij_isModeSubtitle, isModeSubtitle);
</script>

<style scoped lang="scss">
.container-subtitle-settings {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--surface-default);
  padding: 1rem 1rem 0 1rem;
  margin: 1rem;
  border-radius: 16px;
  width: calc(100dvw - 2rem);
  gap: 1rem;
  box-shadow: $shadow-modal;
  z-index: 1;

  @include respond-to(mobile-landscape) {
    height: 100%;
    max-height: 30rem;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.footer-subtitle-settings {
  position: sticky;
  bottom: 0;
  display: flex;
  width: 100%;
  gap: 0.5rem;
  margin-top: auto;
  padding-bottom: 1rem;
  background-color: var(--surface-default);
}

.button-icon {
  position: fixed;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
